export default {
  pl: "pl",
  uk: "uk",
  en: "en"
};
